// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { RemarksComponent } from './remarks.component';
import { DatePipeModule } from 'libraries/date/date.module';
import { TravellerDataTranslationModule } from 'libraries/service/traveller-data-translation/traveller-data-translation.module';

@NgModule({
    imports: [
        CommonModule,
        DatePipeModule,
        TravellerDataTranslationModule,
    ],
    exports: [RemarksComponent],
    declarations: [RemarksComponent],
})
export class RemarksModule { }
